module.exports = __webpack_public_path__ + "img/Logobox.206a6082.svg";